// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidPackageHistoryQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type BidPackageHistoryQuery = { __typename?: 'Query', bidPackage: { __typename?: 'BidPackage', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> } };


export const BidPackageHistoryDocument = gql`
    query BidPackageHistory($id: ID!) {
  bidPackage(id: $id) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useBidPackageHistoryQuery__
 *
 * To run a query within a React component, call `useBidPackageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackageHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBidPackageHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidPackageHistoryQuery, BidPackageHistoryQueryVariables> & ({ variables: BidPackageHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>(BidPackageHistoryDocument, options);
      }
export function useBidPackageHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>(BidPackageHistoryDocument, options);
        }
// @ts-ignore
export function useBidPackageHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>;
export function useBidPackageHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackageHistoryQuery | undefined, BidPackageHistoryQueryVariables>;
export function useBidPackageHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>(BidPackageHistoryDocument, options);
        }
export type BidPackageHistoryQueryHookResult = ReturnType<typeof useBidPackageHistoryQuery>;
export type BidPackageHistoryLazyQueryHookResult = ReturnType<typeof useBidPackageHistoryLazyQuery>;
export type BidPackageHistorySuspenseQueryHookResult = ReturnType<typeof useBidPackageHistorySuspenseQuery>;
export type BidPackageHistoryQueryResult = ApolloReactCommon.QueryResult<BidPackageHistoryQuery, BidPackageHistoryQueryVariables>;